export class PharmacyRequiredError extends Error {
  public constructor() {
    super('Please choose a pharmacy location.');
  }
}
